import { useShallow } from 'zustand/react/shallow';
import { useChallengeFormStore } from '../../NewChallengeForm.store';

export const useUserId = () => {
  return useChallengeFormStore(
    useShallow((s) => ({
      userId: s.challenge.userId,
    })),
  );
};

export const useUserIdActions = () => {
  const updateChallengeForm = useChallengeFormStore(
    (s) => s.updateChallengeForm,
  );

  const setUserId = (userId: number) => updateChallengeForm({ userId });

  return { setUserId };
};
